module.exports = __webpack_public_path__ + "img/math.2ebf1af5.png";